<template>
  <div class="app-container teachjob">
    <div v-if="!isMB" style="margin-bottom: 10px;">
      <el-tabs v-model="active" @tab-click="onClick($event,null)" type="card" class="cardTabs">
        <el-tab-pane label="主题班会" name="0"></el-tab-pane>
        <el-tab-pane label="个人德育类荣誉" name="1"><span class="hint">名班主任、优秀班主任等</span></el-tab-pane>
        <el-tab-pane label="个人德育类获奖" name="2"><span class="hint">如班主任专业能力大赛、德育论文评比等</span></el-tab-pane>
        <el-tab-pane label="所带班级表彰获奖" name="3"><span class="hint">如文明班级、优秀团支部、合唱等班级团体项目获奖</span></el-tab-pane>
      </el-tabs>
    </div>
    <div v-else style="margin-bottom: 10px;">
      <el-tabs v-model="active1" @tab-click="onClick($event,1)" stretch type="card" class="cardTabs">
        <el-tab-pane label="主题班会" name="0"></el-tab-pane>
        <el-tab-pane label="个人德育类荣誉" name="1"><span class="hint">名班主任、优秀班主任等</span></el-tab-pane>
      </el-tabs>
      <el-tabs v-model="active2" @tab-click="onClick($event,2)" stretch type="card" class="cardTabs">
        <el-tab-pane label="个人德育类获奖" name="2"><span class="hint">如班主任专业能力大赛、德育论文评比等</span></el-tab-pane>
        <el-tab-pane label="所带班级表彰获奖" name="3"><span class="hint">如文明班级、优秀团支部、合唱等班级团体项目获奖</span></el-tab-pane>
      </el-tabs>
    </div>    
    <list ref="list" v-if="active==0" :ThemeList="ThemeList" :ThemeLvList="ThemeLvList">
      <template slot="toolbar-right" >
        <el-button type="primary" @click="create('editDialog')" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('list','ThemeId')">删除</el-button>
        <el-button @click="onExport('list')" type="primary" plain>导出</el-button>
        <el-button type="success" plain @click="onImport('list')">导入</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite(path)">
       <el-table-column prop="" label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
             <el-button type="text" style="margin-left: 10px;" @click="editById('editDialog',row.ThemeId)" v-if="(row.Status==0 || row.Status==2) || $permission.canReview(path)">编辑</el-button>
             <el-button type="text" @click="examine('editDialog',row.ThemeId)" >查看</el-button>
                <el-button type="text" v-if="row.Status==1 && $permission.canReview(path)" @click.stop="check(row.ThemeId,'editDialog')" >审核</el-button>
                <el-button type="text" v-if="row.Status==1 && row.AddTeacherId==TeacherId" @click.stop="Cancel(row.ThemeId,'detailsDialog')" >撤销</el-button>
                <el-button type="text" v-if="row.Status==3 && $permission.canReview(path)" @click.stop="CancelPublish(row.ThemeId,'detailsDialog')" >撤销审核</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <list2 ref="list2" v-if="active==1" :ThemeLvList="ThemeLvList">
      <template slot="toolbar-right">
        <el-button type="primary" @click="create('editDialog2')" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('list2','EduHonerId')">删除</el-button>
        <el-button @click="onExport('list2')" type="primary" plain>导出</el-button>
        <el-button type="success" plain @click="onImport('list2')">导入</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite(path)">
       <el-table-column prop="" label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
             <el-button type="text" style="margin-left: 10px;" @click="editById('editDialog2',row.EduHonerId)" v-if="(row.Status==0 || row.Status==2) || $permission.canReview(path)">编辑</el-button>
              <el-button type="text" @click="examine('editDialog2',row.EduHonerId)" >查看</el-button>
                <el-button type="text" v-if="row.Status==1 && $permission.canReview(path)" @click.stop="check(row.EduHonerId,'editDialog2')" >审核</el-button>
                <el-button type="text" v-if="row.Status==1 && row.AddTeacherId==TeacherId" @click.stop="Cancel(row.EduHonerId,'detailsDialog2')" >撤销</el-button>
                <el-button type="text" v-if="row.Status==3 && $permission.canReview(path)" @click.stop="CancelPublish(row.EduHonerId,'detailsDialog2')" >撤销审核</el-button>
          </template>
        </el-table-column>
      </template>
    </list2>
    <list3 ref="list3" v-if="active==2"  :ThemeList="ThemeList" :ThemeLvList="ThemeLvList" :GradeList="GradeList" :awardsList="awardsList">
      <template slot="toolbar-right" @canExport="canExport">
       <el-button type="primary" @click="create('editDialog3')" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('list3','EduAwardId')">删除</el-button>
        <el-button @click="onExport('list3')" type="primary" plain>导出</el-button>
        <el-button type="success" plain @click="onImport('list3')">导入</el-button>
      </template>
            <template slot="column" v-if="$permission.canWrite(path)">
       <el-table-column prop="" label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
             <el-button type="text" style="margin-left: 10px;" @click="editById('editDialog3',row.EduAwardId)" v-if="(row.Status==0 || row.Status==2) || $permission.canReview(path)">编辑</el-button>
             <el-button type="text" @click="examine('editDialog3',row.EduAwardId)" >查看</el-button>
                <el-button type="text" v-if="row.Status==1 && $permission.canReview(path)" @click.stop="check(row.EduAwardId,'editDialog3')" >审核</el-button>
                <el-button type="text" v-if="row.Status==1 && row.AddTeacherId==TeacherId" @click.stop="Cancel(row.EduAwardId,'detailsDialog3')" >撤销</el-button>
                <el-button type="text" v-if="row.Status==3 && $permission.canReview(path)" @click.stop="CancelPublish(row.EduAwardId,'detailsDialog3')" >撤销审核</el-button>
          </template>
        </el-table-column>
      </template>
    </list3>
    <list4 ref="list4" v-if="active==3"  :ThemeList="ThemeList" :ThemeLvList="ThemeLvList" :GradeList="GradeList" :commendList="commendList">
      <template slot="toolbar-right" @canExport="canExport">
       <el-button type="primary" @click="create('editDialog4')" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows('list4','ClassAwardId')">删除</el-button>
        <el-button @click="onExport('list4')" type="primary" plain>导出</el-button>
        <el-button type="success" plain @click="onImport('list4')">导入</el-button>
      </template>
            <template slot="column" v-if="$permission.canWrite(path)">
       <el-table-column prop="" label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
             <el-button type="text" style="margin-left: 10px;" @click="editById('editDialog4',row.ClassAwardId)" v-if="(row.Status==0 || row.Status==2) || $permission.canReview(path)">编辑</el-button>
              <el-button type="text" @click="examine('editDialog4',row.ClassAwardId)" >查看</el-button>
                <el-button type="text" v-if="row.Status==1 && $permission.canReview(path)" @click.stop="check(row.ClassAwardId,'editDialog4')" >审核</el-button>
                <el-button type="text" v-if="row.Status==1 && row.AddTeacherId==TeacherId" @click.stop="Cancel(row.ClassAwardId,'detailsDialog4')" >撤销</el-button>
                <el-button type="text" v-if="row.Status==3 && $permission.canReview(path)" @click.stop="CancelPublish(row.ClassAwardId,'detailsDialog4')" >撤销审核</el-button>
          </template>
        </el-table-column>
      </template>
    </list4>
    <edit-dialog ref="editDialog" @close-saved="reload" :ThemeList="ThemeList" :ThemeLvList="ThemeLvList"></edit-dialog>
    <edit-dialog2 ref="editDialog2" @close-saved="reload" :ThemeLvList="ThemeLvList" :restaurants="restaurants"></edit-dialog2>
    <edit-dialog3 ref="editDialog3" @close-saved="reload" :ThemeList="ThemeList" :ThemeLvList="ThemeLvList" :awardsList="awardsList" :GradeList="GradeList"></edit-dialog3>
    <edit-dialog4 ref="editDialog4" @close-saved="reload" :ThemeList="ThemeList" :ThemeLvList="ThemeLvList" :commendList="commendList" :GradeList="GradeList"></edit-dialog4>
    <details-dialog ref="detailsDialog" @close-saved="reload"></details-dialog>
    <details-dialog2 ref="detailsDialog2" @close-saved="reload"></details-dialog2>
    <details-dialog3 ref="detailsDialog3" @close-saved="reload"></details-dialog3>
    <details-dialog4 ref="detailsDialog4" @close-saved="reload"></details-dialog4>
  </div>
</template>
<script>
import router from '@/router'
import curdMixins from "@/mixins/curd";
import list from "@/components/gd/teachjob/list/list";
import list2 from "@/components/gd/teachjob/list2/list2";
import list3 from "@/components/gd/teachjob/list3/list3";
import list4 from "@/components/gd/teachjob/list4/list";
import editDialog from "@/components/gd/teachjob/list/editDialog";
import editDialog2 from "@/components/gd/teachjob/list2/editDialog2";
import editDialog3 from "@/components/gd/teachjob/list3/editDialog";
import editDialog4 from "@/components/gd/teachjob/list4/editDialog";
import detailsDialog from "@/components/gd/teachjob/list/detailsDialog";
import detailsDialog2 from "@/components/gd/teachjob/list2/detailsDialog";
import detailsDialog3 from "@/components/gd/teachjob/list3/detailsDialog";
import detailsDialog4 from "@/components/gd/teachjob/list4/detailsDialog";
export default {
  name: "warning",
  mixins: [curdMixins],
  components: {
    list,
    list2,
    list3,
    list4,
    editDialog,
    detailsDialog,
    editDialog2,
    detailsDialog2,
    detailsDialog3,
    editDialog3,
    editDialog4,
    detailsDialog4,
  },
  data() {
    return {
      path:router.history.current.path,
      TeacherId:JSON.parse(localStorage.getItem("loginInfo")).TeacherId,
      Base_api: require("@/api/gd/basedata").default,
      active: "0",
      active1: "0",
      active2: "-",
      last: -1,
      isMB: this.$store.state.isMB,
      listexport: false,
      ThemeList:[],
      ThemeLvList:[],
      GradeList:[],
      restaurants:[],
      awardsList:[],
      commendList:[],
      editList:['editDialog','editDialog2','editDialog3','editDialog4'],
      listref:['list','list2','list3','list4'],
      apilist:[ require("@/api/gd/theme").default,require("@/api/gd/eduhoner").default,
      require("@/api/gd/eduaward").default,require("@/api/gd/classaward").default]
    }
  },
  mounted() {
    this.Base_api.list({ClassName:'类型',Status:1}).then(res => {
      if(res.Code==0){
         this.ThemeList=res.Data
      }
    })
    this.Base_api.list({ClassName:'级别',Status:1}).then(res => {
      if(res.Code==0){
         this.ThemeLvList=res.Data
      }
    })
    this.Base_api.list({ClassName:'等次',Status:1}).then(res => {
      if(res.Code==0){
         this.GradeList=res.Data
      }
    })
    this.Base_api.list({ClassName:'德育类荣誉名称',Status:1}).then(res => {
      if(res.Code==0){
        res.Data.forEach(e=>{
          this.restaurants.push({ "value": e.DataName, "DataName": e.DataName })
        })
      }
    })
    this.Base_api.list({ClassName:'德育类奖项名称',Status:1}).then(res => {
      if(res.Code==0){
        res.Data.forEach(e=>{
          this.awardsList.push({ "value": e.DataName, "DataName": e.DataName })
        })
      }
    })
    this.Base_api.list({ClassName:'所带班级表彰名称',Status:1}).then(res => {
      if(res.Code==0){
        res.Data.forEach(e=>{
          this.commendList.push({ "value": e.DataName, "DataName": e.DataName })
        })
      }
    })
    if(this.$route.query.id){
       this.$nextTick(e=>{
      this.$refs[this.listref[this.$route.query.type]].reload()
        this.apilist[this.$route.query.type].info(this.$route.query.id).then(res => {
               if(res.Data.Status==1){
                  this.check(this.$route.query.id,this.editList[this.$route.query.type])
               }else{
                  this.editById(this.editList[this.$route.query.type],this.$route.query.id)
               }
          })
      this.active=this.$route.query.type
      })
    }
  },
  methods: {
    examine(name,id){
       sessionStorage.setItem('check','2')
       this.$refs[name].openEditById(id);
    },
    editById(name,id){
       this.$refs[name].openEditById(id);
    },
    create(name){
        this.$refs[name].openCreate()
    },
    onImport(name) {
      this.$refs[name].onImport();
    },
    Cancel(id,name) {
      sessionStorage.setItem('cancel','1')
      this.$refs[name].openEditById(id);
    },
    CancelPublish(id,name) {
      sessionStorage.setItem('cancel','2')
      this.$refs[name].openEditById(id);
    },
    check(id,name) {
      sessionStorage.setItem('check','1')
      // this.editById(row.ThemeId);
      this.$refs[name].openEditById(id);
    },
    reload() {
      if(this.active=='0') {
        this.$refs.list.reload();
      } else if(this.active=='1') {
        this.$refs.list2.reload();
      } else if(this.active=='2') {
        this.$refs.list3.reload();
      } else if(this.active=='3') {
        this.$refs.list4.reload();
      }
    },
    onExport(name) {
      this.$refs[name].onExport();
    },
    onClick(e,type) {
     if(type!=null){
        this.active1='-';
        this.active2='-';
        this['active'+type] = e.name;
     }
      this.active = e.name;
         this.$nextTick(()=>{
            if(this.active=='0') {
              this.$refs.list.reload();
            } else if(this.active=='1') {
              this.$refs.list2.reload();
            } else if(this.active=='2') {
              this.$refs.list3.reload();
            } else if(this.active=='3') {
              this.$refs.list4.reload();
            }
         })
    },
    canExport(bool) {
      this.listexport = bool;
    },
    cancel(ids) {
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {

          this.$refs.list.cancel(ids);
        })
        .catch(() => {});
    },
    delRows(name,id) {
      let rows = this.$refs[name].getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item[id];
          });
          this.$refs[name].delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss">
.hint{
    color: red;font-weight: bolder;
}
.teachjob .el-tabs .el-tabs__header{
  margin: 0 !important;
}
</style>